export default "__VITE_ASSET__DXJ67Qlc__"